import { styled } from 'styled-components';

import { colors } from '#/theme/theme';

export const DetailsListGroupHolder = styled.div`
  display: inline-block;
  width: 100%;
  vertical-align: top;
  margin-top: 16px;
`;

export const DetailsListGroupHeader = styled.header`
  display: flex;
  align-items: center;
  color: ${colors.mediumContentGrey};
`;

export const DetailsListGroupTooltip = styled.div`
  margin-left: 4px;
`;

export const DetailsListGroupItems = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  gap: 4px;
`;
